import { IMeetingRequestAttributes } from '@/interfaces/events/IMeetingRequestAttributes';
import { AppCollection } from '@/stores/AppStore';

export function mutateEventSponsorMeetingRequest(
  store: AppCollection,
  sponsorId: string,
  payload: IMeetingRequestAttributes
) {
  return store.request(`event_sponsors/${sponsorId}/meeting_requests`, 'POST', {
    data: {
      type: 'meeting_request',
      attributes: {
        ...payload,
        event_sponsor_id: sponsorId,
      },
    },
  });
}
